import React, { ErrorInfo } from "react";

interface Props {
    children: React.ReactNode;
}

interface State {
    hasError: boolean;
}

const loadingChunkFailedRegex = /Loading chunk \w+ failed/g;

export default class TaxGuruCodeSplittingErrorBoundary extends React.Component<Props, State> {
    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error(error, errorInfo);
        if (loadingChunkFailedRegex.test(error.message) || loadingChunkFailedRegex.test(error.name)) {
            location.reload();
        }
    }

    public render() {
        return this.props.children;
    }
}
